// apps/spa/src/components/auth/SessionExpiredModal.tsx
// 401 in-place modal. Subscribes to useSessionExpired() which listens for the
// 'session-expired' CustomEvent fired by lib/api.ts on every 401 response.
//
// Non-dismissable per CONTEXT 401 contract — no X button, no ESC key, no
// backdrop click. The single primary action 'Log in again' redirects to
// /api/auth/start?returnTo=<current pathname> for explicit re-auth.
//
// Implementation: hand-rolled fixed-position div + backdrop. Avoids the
// shadcn <Dialog> auto-close-on-ESC behavior that would violate the contract.
//
// LOCKED copy: "Your session expired. Log in to continue where you left off."

import { Button } from '@/components/ui/button';
import { useSessionExpired } from '@/hooks/useSessionExpired';

export function SessionExpiredModal() {
  const { open, loginAgain } = useSessionExpired();

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-expired-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
    >
      <div className="glass glass-2 w-full max-w-md rounded-[var(--radius-card-lg)] p-6">
        <h2
          id="session-expired-title"
          className="font-display text-xl font-semibold text-primary"
        >
          Session expired
        </h2>
        <p className="mt-3 text-sm text-foreground">
          Your session expired. Log in to continue where you left off.
        </p>
        <div className="mt-6 flex justify-end">
          <Button onClick={loginAgain}>Log in again</Button>
        </div>
      </div>
    </div>
  );
}
